import type { RecordingId } from "@repo/app-types/entities/recording";
import type {
  CallOutlineSegment,
  TeammateAccountCallOutline,
} from "@repo/app-types/entities/teammateAccountCallOutline";
import type { AccountGradingRecording } from "@repo/app-types/entities/teammatePerformanceSummary";

export interface CallPosition {
  recordingId: RecordingId;
  timestamp: number;
  /** Exact transcript fragment for positions resolved from call navigation. */
  fragmentIndex?: number;
}

export function checkCallSegmentContainsPosition(
  recordingId: RecordingId,
  segment: CallOutlineSegment,
  position: CallPosition | undefined,
): boolean {
  return (
    position?.recordingId === recordingId &&
    position.timestamp >= segment.start_timestamp &&
    position.timestamp < segment.end_timestamp
  );
}

export function buildCallNavigationItems(
  recordings: readonly AccountGradingRecording[],
  callOutline: TeammateAccountCallOutline | undefined,
) {
  const outlinesByRecordingId = new Map(
    callOutline?.calls.map((call) => [call.recording_id, call]) ?? [],
  );

  return recordings.map((recording, index) => {
    const outline = outlinesByRecordingId.get(recording.id);
    return {
      recording,
      callNumber: index + 1,
      title:
        outline?.title?.trim() || recording.title.trim() || `Call ${index + 1}`,
      segments: outline?.segments ?? [],
    };
  });
}
